
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'ApiEnumFormation',
  props: {
    apiData: { type: Object, default: () => {} },
  },
  created() {
    this.bestPicFormat = bestPicFormat
  },
}
